import React from "react";
import "./associationDetails.scss";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { Button, Stack } from "react-bootstrap";
import { t } from "i18next";

const AssociationDetails = ({
  image,
  name,
  dateOfFoundation,
  address,
  idAssociation,
}) => {
  return (
    <div className="association-details-container">
      <Stack className="d-flex justify-content-between align-items-center h-100 w-100">
        {/**Immagine e nome associazione */}
        <Stack gap={0} className="w-100 d-flex align-items-center">
          <img
            src={image}
            alt="immagine_associazione"
            className="img-association"
          />
          <span className="name-association">{name}</span>
        </Stack>

        {/**Data di fondazione e indirizzo */}
        <Stack gap={2} className="h-100 d-flex justify-content-center">
          <Stack
            direction="horizontal"
            gap={1}
            className="d-flex justify-content-center"
          >
            <CalendarMonthIcon sx={{ color: "#03626E" }} />
            <span className="data-association-text">{dateOfFoundation}</span>
          </Stack>
          <Stack
            direction="horizontal"
            gap={1}
            className="d-flex justify-content-center "
          >
            <LocationOnIcon sx={{ color: "#03626E" }} />
            <span className="data-association-text">{address}</span>
          </Stack>
        </Stack>

        <div className="d-flex align-itmes-center">
          <Button
            variant="info"
            size="sm"
            href={`/association/${idAssociation}?preview=true`}
            style={{ borderRadius: 7 }}
          >
            <Stack
              direction="horizontal"
              gap={2}
              className="d-flex justify-content-between align-items-center"
            >
              <span>{t("dashboard.view_page_association")}</span>
              <KeyboardArrowRightIcon sx={{ height: 20, width: 20 }} />
            </Stack>
          </Button>
        </div>

        <Stack gap={1}></Stack>
      </Stack>
    </div>
  );
};

export default AssociationDetails;
